import React from 'react'

import {
  Box,
  Grid,
  Typography,
} from '@mui/material'

const LandingWhom = (props) => {
  return (
    <Grid container spacing={2} p={8} py={8} sx={{ bgcolor: 'white' }} alignItems='center'>
      <Grid item xs={12} md={6} align='center' sx={{ display: { xs: 'none', md: 'block' } }}>
        <Box
          component='img'
          src='/assets/images/whom-circle.png'
          sx={{ width: '80%' }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography color='primary' variant='h3' gutterBottom>
          <b style={{ fontWeight: 900 }}>¿Para quién?</b>
        </Typography>
        <Typography color='#00c08b' variant='h5' gutterBottom>
          <b style={{ fontWeight: 700 }}>Una nueva generación de estudiantes y preceptores</b>
        </Typography>
        <Typography variant='body1'>
          Para todas las instituciones educativas que busquen el crecimiento exponencial e integral de los estudiantes mediante un acompañamiento personal.
        </Typography>
      </Grid>
    </Grid>
  )
}

export default LandingWhom